export const SET_PERIODO = 'SET_PERIODO'
export const SET_INDICADORES_ABERTOS = 'SET_INDICADORES_ABERTOS'
export const SET_INDICADOR_SELECTED_ID = 'SET_INDICADOR_SELECTED_ID'
export const SET_NOTAS = 'SET_NOTAS'
export const SET_PERIODO_LIST = 'SET_PERIODO_LIST'



// WEBPACK FOOTER //
// ./src/features/Relatorio/store/mutation-types.js